import { geometryDebugStore } from '@utils/geometryIntegrity/debug'
import { useAppStore } from '@store'

function focusUnit(unitId: string) {
  const store = useAppStore.getState()
  store.unselectAll()
  store.select(unitId as never, false)
  store.setCurrentObjectID(unitId as never)
}

/** Aviso de un proyecto cargado con volúmenes ya solapados. No mueve las unidades. */
export function GeometryIntegrityNotice() {
  const pairs = geometryDebugStore((state) => state.persistedCollisions)
  const dismiss = geometryDebugStore((state) => state.dismissPersisted)
  if (!pairs || pairs.length === 0) return null

  return (
    <div className='pointer-events-auto fixed left-1/2 top-4 z-[80] w-[min(640px,calc(100%-2rem))] -translate-x-1/2 rounded-md border border-red-300 bg-white p-4 text-sm text-zinc-900 shadow-lg'>
      <p className='font-semibold text-red-700'>El proyecto contiene unidades solapadas.</p>
      <p className='mt-1 text-zinc-600'>
        La geometría guardada no se ha movido. Las operaciones nuevas no pueden confirmar otra pose que
        intersecte volumen.
      </p>
      <ul className='mt-3 max-h-40 space-y-2 overflow-auto'>
        {pairs.map((pair) => (
          <li key={`${pair.unitA}:${pair.unitB}`} className='rounded bg-red-50 px-2 py-1'>
            <span className='font-medium'>{pair.unitA}</span>
            <span> intersecta </span>
            <span className='font-medium'>{pair.unitB}</span>
            <span className='text-zinc-500'> ({pair.overlapMm.toFixed(1)} mm)</span>
            <span className='ml-2'>
              <button type='button' className='underline' onClick={() => focusUnit(pair.unitA)}>
                Ver {pair.unitA}
              </button>
              <span> · </span>
              <button type='button' className='underline' onClick={() => focusUnit(pair.unitB)}>
                Ver {pair.unitB}
              </button>
            </span>
          </li>
        ))}
      </ul>
      <button type='button' className='mt-3 text-zinc-500 underline' onClick={dismiss}>
        Cerrar
      </button>
    </div>
  )
}
